import { Stack, TextField, IconButton, Card, Typography, Button, CardMedia, CardContent, Autocomplete } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";


export function CarouselBuilder({ value = [], onChange, templateType, handlePreview, products = [] }) {
  const max = 10;
  const maxButtons = 10;
  const isProductCarousel = templateType === "product_card_carousel";


  const addCard = () => {
    if ((value?.length || 0) >= max) return;
    const base = { title: "", description: "", buttons: [] };
    const card = isProductCarousel
      ? { ...base, product_id: "", image_id: "" } // product images come from catalog, keep optional title/desc/buttons
      : { ...base, image_id: "", image_file: null }; // media carousel uses uploaded image or existing media_id
    const next = [...(value || []), card];
    onChange(next);
    handlePreview && handlePreview();
  };


  const updateCard = (i, patch) => {
    const next = [...value];
    next[i] = { ...next[i], ...patch };
    onChange(next);
    handlePreview && handlePreview();
  };


  const removeCard = (i) => {
    const next = [...value];
    next.splice(i, 1);
    onChange(next);
    handlePreview && handlePreview();
  };


  const addButton = (i) => {
    const next = [...value];
    const currentButtons = next[i].buttons || [];
    if (currentButtons.length >= maxButtons) return;
    next[i].buttons = [...(next[i].buttons || []), { type: "url", text: "", url: "" }];
    onChange(next);
    handlePreview && handlePreview();
  };


  const updateButton = (i, bi, patch) => {
    const next = [...value];
    const buttons = next[i].buttons || [];
    buttons[bi] = { ...(buttons[bi] || {}), ...patch };
    next[i].buttons = buttons;
    onChange(next);
    handlePreview && handlePreview();
  };


  const removeButton = (i, bi) => {
    const next = [...value];
    next[i].buttons.splice(bi, 1);
    onChange(next);
    handlePreview && handlePreview();
  };


  return (
    <Stack gap={1} sx={{ mt: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle2">Cards</Typography>
        <IconButton onClick={addCard} disabled={(value?.length || 0) >= max} sx={{ color: "#25d366" }}>
          <AddCircleIcon />
        </IconButton>
      </Stack>


      {value?.map((card, i) => {
        const previewSrc = card.image_file ? URL.createObjectURL(card.image_file) : null;
        const buttonCount = card.buttons?.length || 0;


        return (
          <Card key={i} sx={{ p: 2 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography variant="body2">Card {i + 1}</Typography>
              <IconButton onClick={() => removeCard(i)} sx={{ color: "#df1d5a" }}>
                <RemoveCircleIcon />
              </IconButton>
            </Stack>


            <Stack gap={1} sx={{ mt: 1 }}>
              {isProductCarousel ? (
                <Autocomplete
                  value={products.find((p) => p.retailer_id === card.product_id) || null}
                  options={products}
                  getOptionLabel={(opt) => [opt?.name, opt?.retailer_id].filter(Boolean).join(" — ")}
                  onChange={(e, data) => {
                    const next = [...value];
                    next[i] = {
                      ...next[i],
                      product_id: data?.retailer_id || "",
                      title: data?.name || "",
                      price: data?.price || "",
                      image_url: data?.image_url || "",
                    };
                    onChange(next);
                    handlePreview && handlePreview();
                  }}
                  renderInput={(params) => <TextField {...params} label="Select Product" size="small" />}
                  sx={{ mb: 1 }}
                />
              ) : (
                <>
                  {previewSrc && (
                    <CardMedia component="img" image={previewSrc} sx={{ height: 140, objectFit: "cover", borderRadius: 1 }} />
                  )}
                  <Stack direction="row" alignItems="center" gap={1}>
                    <Button variant="contained" component="label" size="small">
                      Upload image
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files?.[0];
                          if (file) updateCard(i, { image_file: file });
                        }}
                      />
                    </Button>
                    {/* <TextField
                      label="Image ID (optional)"
                      size="small"
                      value={card.image_id || ""}
                      onChange={(e) => updateCard(i, { image_id: e.target.value })}
                    /> */}
                  </Stack>
                  {/* <TextField
                    label="Title"
                    size="small"
                    value={card.title || ""}
                    onChange={(e) => updateCard(i, { title: e.target.value })}
                  /> */}
                  <TextField
                    label="Description"
                    size="small"
                    value={card.description || ""}
                    onChange={(e) => updateCard(i, { description: e.target.value })}
                  />
                </>
              )}




              {!isProductCarousel && (
              <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 1 }}>
                <Typography variant="caption">Buttons</Typography>
                <Button onClick={() => addButton(i)} size="small" disabled={buttonCount >= maxButtons}>Add button</Button>
              </Stack>
              )}


              {(card.buttons || []).map((btn, bi) => (
                <Stack key={bi} direction="row" gap={1} alignItems="center">
                  <TextField
                    label="Type"
                    size="small"
                    value={btn.type || "url"}
                    onChange={(e) => updateButton(i, bi, { type: e.target.value })}
                  />
                  <TextField
                    label="Text"
                    size="small"
                    value={btn.text || ""}
                    onChange={(e) => updateButton(i, bi, { text: e.target.value })}
                  />
                  <TextField
                    label="URL (type=url)"
                    size="small"
                    value={btn.url || ""}
                    onChange={(e) => updateButton(i, bi, { url: e.target.value })}
                  />
                  <IconButton onClick={() => removeButton(i, bi)} sx={{ color: "#df1d5a" }}>
                    <RemoveCircleIcon />
                  </IconButton>
                </Stack>
              ))}
            </Stack>
          </Card>
        );
      })}
    </Stack>
  );
}